import { Button, Checkbox, Dropdown, DropdownItemProps, Form, FormProps, Input, Modal, Segment, Table, TextArea } from "semantic-ui-react";
import { useCurrentUser } from "../hooks/auth-hook";
import { useEffect, useState } from "react";
import { DELETING_FILE_STATUS_APPROVE, DELETING_FILE_STATUS_DISAPPROVE, DELETING_FILE_STATUS_NEW, DELETING_FILE_STATUS_SUBMIT, DeletingTestingFile, DeletingTestingFileItem, DeletingTestingFileStatusNames } from "../models/deleting_testing_file_model";
import { useFormConnect, useFormData } from "../hooks/formHooks";
import { PageData } from "../models/common_model";
import { fieldError, formatDateTime } from "../utils";
import { ModalControlData, useModalControl } from "../hooks/commonHooks";
import { dialogControl } from "../controls/dialog-control";
import { restRequest } from "../http";
import { Page } from "./commons/Page";
import { TextEditor } from "./commons/TextEditor";
import _ from "lodash";
import { DropdownOption } from "../models/testing_model";


export function DeletingTestingFileComponent(props: any)
{
    const [searchData, setSearchField] = useFormData<any>({});
    const [list, setSearchData, isListLoading] = useFormConnect<any, PageData<DeletingTestingFile>>({}, 'file_sync/deleting_testing_file/search');
    const editModalControl = useModalControl<DeletingTestingFile>(null as any);

    const [testingResultDropdownOptions, setTestingResultDropdownOptions] = useState<DropdownOption[]>([]);
    const [productOptions, setProductOptions] = useState<DropdownItemProps[]>([]);
    const [stationOptions, setStationOptions] = useState<DropdownItemProps[]>([]);
    const [orderOptions, setOrderOptions] = useState<DropdownItemProps[]>([]);
    useEffect(() => {
        restRequest<DropdownOption[]>('svn_repository/result_dropdown_options').then(setTestingResultDropdownOptions)
    }, []);

    useEffect(() => {
        const options = [{ key: '', text: 'All', value: '' }, ...testingResultDropdownOptions.map(t => ({ key: t.name, text: t.name, value: t.name }))];
        setProductOptions(options);
        if (!options.find(o => o.value == searchData.product)) {
            setSearchField(null, { name: 'product', value: '' });
            setSearchField(null, { name: 'station', value: '' });
            setSearchField(null, { name: 'order', value: '' });
        }
    }, [testingResultDropdownOptions]);

    useEffect(() => {
        const product = testingResultDropdownOptions.find(t => t.name == searchData.product);
        let options: DropdownItemProps[];
        if (product) {
            options = [{ key: '', text: 'All', value: '' }, ...product.children.map(t => ({ key: t.name, text: t.name, value: t.name }))];
        } else {
            options = [{ key: '', text: 'All', value: '' }];
        }

        setOrderOptions(options);

        if (!options.find(o => o.value == searchData.station)) {
            setSearchField(null, { name: 'station', value: '' });
            setSearchField(null, { name: 'order', value: '' });
        }
    }, [testingResultDropdownOptions, searchData.product]);

    useEffect(() => {
        let options: DropdownItemProps[] = [{ key: '', text: 'All', value: '' }];
        const product = testingResultDropdownOptions.find(t => t.name == searchData.product);
        if (product) {
            const station = product.children.find(s => s.name == searchData.order);
            if (station) {
                options = [{ key: '', text: 'All', value: '' }, ...station.children.map(t => ({ key: t.name, text: t.name, value: t.name }))];
            }
        }

        setStationOptions(options);

        if (!options.find(o => o.value == searchData.order)) {
            setSearchField(null, { name: 'station', value: '' });
        }
    }, [testingResultDropdownOptions, searchData.product, searchData.order]);

    const currentUser = useCurrentUser();
    return <>
        <Segment.Group>
            <Segment attached="top" loading={isListLoading}>
                <Form onSubmit={e => {
                  setSearchData({...searchData, refresh: (searchData.refresh || 0) + 1});
                }}>
                    <Form.Group>
                        <Form.Input inline label="Product" style={{ minWidth: '10rem' }}>
                            <Dropdown name="product" value={searchData.product || ''} onChange={setSearchField} options={productOptions} search selection fluid></Dropdown>
                        </Form.Input>

                        <Form.Input label="Build" inline style={{ minWidth: '3rem' }}>
                            <Dropdown name="order" value={searchData.order || ''} onChange={setSearchField} options={orderOptions} search selection fluid></Dropdown>
                        </Form.Input>

                        <Form.Input label="Station" inline style={{ minWidth: '10rem' }}>
                            <Dropdown name="testing_station" value={searchData.testing_station || ''} onChange={setSearchField} options={stationOptions} search selection fluid></Dropdown>
                        </Form.Input>

                        <Form.Input label="Status" inline style={{ minWidth: '10rem' }}>
                            <Dropdown name="status" value={searchData.status || ''} onChange={setSearchField} options={[{ key: 0, text: 'All', value: 0 }, ...DeletingTestingFileStatusNames.filter(v => !!v).map((text, index) => ({key: index + 1, text, value: index + 1}))]} search selection fluid></Dropdown>
                        </Form.Input>

                        <Form.Input label="Created By Me" inline style={{ minWidth: '10rem' }}>
                            <Dropdown name="mine" value={searchData.mine || ''} onChange={setSearchField} options={[{ key: 0, text: 'All', value: '' }, { key: 1, text: 'Yes', value: 1 }, { key: 2, text: 'No', value: 2 }]} search selection fluid></Dropdown>
                        </Form.Input>

                        <div style={{paddingLeft: '2rem'}}><Button icon="search" type="submit"></Button></div>
                    </Form.Group>
                </Form>
            </Segment>
            <Segment attached="bottom">
                <Table striped>
                    <Table.Header>
                        <Table.Row>
                            <th>Status</th>
                            <th>Product</th>
                            <th>Order</th>
                            <th>Testing Station</th>
                            <th>Created By</th>
                            <th>Submitted At</th>
                            <th>Audited By</th>
                            <th>Audit At</th>
                            <th></th>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {list?.items.map(obj => {
                            return <tr key={obj.id}>
                                <td>{DeletingTestingFileStatusNames[obj.status]}</td>
                                <td>{obj.product}</td>
                                <td>{obj.order}</td>
                                <td>{obj.testing_station}</td>
                                <td>{obj.created_by_name}</td>
                                <td>{formatDateTime(obj.submitted_at)}</td>
                                <td>{obj.audited_by_name}</td>
                                <td>{formatDateTime(obj.audited_at)}</td>
                                <td>
                                    {(obj.is_mine || currentUser.permissions.file_sync.delete_file.audit) && <Button onClick={e => {
                                        editModalControl.data = obj;
                                        editModalControl.setOpen(true);
                                    }} color="blue" icon="edit" size="mini" />}

                                    {[DELETING_FILE_STATUS_NEW, DELETING_FILE_STATUS_SUBMIT].includes(obj.status) && obj.is_mine && <Button onClick={e => {
                                        dialogControl.deletionConfirm(obj.product, argee => {
                                            if (argee) {
                                                return restRequest(`file_sync/deleting_testing_file/${obj.id}`, null, 'delete').then(() => {
                                                    setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 }));
                                                })
                                            }
                                            return Promise.resolve()
                                        })
                                    }} color="red" icon="delete" size="mini" />}
                                </td>
                            </tr>
                        })}
                    </Table.Body>
                </Table>
                <Page data={list} updatePage={setSearchData}></Page>
            </Segment>
        </Segment.Group>

        {editModalControl.data && <Editor modalControl={editModalControl} onFinish={result => {
            setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 }));
            editModalControl.setOpen(false)
            setSearchData((sd: any) => ({...sd, refreshNumber: (sd.refreshNumber || 0) + 1}))
        }}></Editor>}
    </>
}


function Editor(props: { modalControl: ModalControlData<DeletingTestingFile>, onFinish: (data: DeletingTestingFile) => void }) {
    const { modalControl, onFinish } = props;
    const id = modalControl.data.id;
    const currentUser = useCurrentUser();
    const [toStatus, setToStatus] = useState(DELETING_FILE_STATUS_SUBMIT);

    const [data, setField, setData] = useFormData<DeletingTestingFile>(modalControl.data);
    const [invalidError, setInvalidError] = useState<any>({});
    const [loading, setLoading] = useState(false);

    const [searchData, setSearchField] = useFormData<any>({});
    const [files, setSearchData, pageLoading] = useFormConnect<any, PageData<DeletingTestingFileItem>>({}, `file_sync/deleting_testing_file/${id}/files`);

    useEffect(() => {
        setData(modalControl.data);
        setInvalidError({});
    }, [id, modalControl.props.open]);

    const onSubmit = (event: React.FormEvent<HTMLFormElement>, formProps: FormProps) => {
        event.preventDefault();

        setLoading(true);
        const formData = {
          note: toStatus === DELETING_FILE_STATUS_SUBMIT ? data.note : data.audit_note
        }
        restRequest<DeletingTestingFile>(`file_sync/deleting_testing_file/${id}/${toStatus}`, formData, 'put').then(result => {
            props.onFinish(result);
            setInvalidError({});
        }, resp => {
            if (resp.status === 2) {
                setInvalidError(resp.data);
            }
        }).finally(() => setLoading(false));
    }


    return (
      <>
        <Modal {...modalControl.props} size="large">
          <Modal.Header>
            {" "}
            {data.status < DELETING_FILE_STATUS_SUBMIT
              ? "Submit"
              : "Audit"}{" "}
            Deleting Files
          </Modal.Header>
          <Modal.Content>
            <Segment.Group>
              <Segment attached="top">
              <Segment.Group>
            <Segment attached="top" compact>
                <Form onSubmit={e => setSearchData(searchData)}>
                    <Form.Group>
                        <Form.Field inline>
                            <Input placeholder="File Name or Serial Number" name="name" value={searchData['name'] || ''} onChange={setSearchField} style={{width: '20rem'}}/>
                        </Form.Field>

                        <div><Button icon="search" type="submit"></Button></div>
                    </Form.Group>
                </Form>
            </Segment>
            <Segment attached="bottom" compact>
                <Table striped compact>
                    <Table.Header>
                        <Table.Row>
                            <th>Serial Number</th>
                            <th>File</th>
                            <th>Created At</th>
                            <th></th>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {files?.items.map(obj => {
                            return (
                              <tr key={obj.file_id}>
                                <td>{obj.serial_number}</td>
                                <td>{_.last(obj.file_path.split("/"))}</td>
                                <td>{formatDateTime(obj.created_at)}</td>
                                <td>
                                  {data.status !== DELETING_FILE_STATUS_APPROVE && <Button
                                    size="mini"
                                    target="_blank"
                                    as="a"
                                    href={`/testing_file_visual/${obj.file_id}`}
                                    icon="search"
                                  ></Button>}
                                </td>
                              </tr>
                            );
                        })}
                    </Table.Body>
                </Table>
                <Page data={files} updatePage={setSearchData}></Page>
            </Segment>
        </Segment.Group>
              </Segment>
              <Segment attached="bottom">
                <Form onSubmit={onSubmit} loading={loading}>
                  <Form.Group widths="equal">
                    <Form.Input label="Product">
                      <span>{data.product}</span>
                    </Form.Input>
                    <Form.Input label="Order">
                      <span>{data.order}</span>
                    </Form.Input>
                    <Form.Input label="Testing Station">
                      <span>{data.testing_station}</span>
                    </Form.Input>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Input label="Status">
                      <span>{DeletingTestingFileStatusNames[data.status]}</span>
                    </Form.Input>
                    <Form.Input label="Created by">
                      <span>{data.created_by_name}</span>
                    </Form.Input>
                    <Form.Input label="Submited at">
                      <span>{formatDateTime(data.submitted_at)}</span>
                    </Form.Input>
                  </Form.Group>
                  {data.status >= DELETING_FILE_STATUS_APPROVE && (
                    <Form.Group widths="equal">
                      <Form.Input label="Audited by">
                        <span>{data.audited_by_name}</span>
                      </Form.Input>
                      <Form.Input label="Audited at">
                        <span>{formatDateTime(data.audited_at)}</span>
                      </Form.Input>
                    </Form.Group>
                  )}
                  <Form.Group widths="equal">
                    <Form.Input
                      required
                      label="Submit Note"
                      error={fieldError("note", invalidError, "below")}
                    >
                      {data.status < DELETING_FILE_STATUS_SUBMIT ? (
                        <TextEditor
                          name="note"
                          value={data.note}
                          onChange={setField}
                        ></TextEditor>
                      ) : (
                        <span dangerouslySetInnerHTML={{__html: data.note}}></span>
                      )}
                    </Form.Input>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Input
                      required
                      label="Audit Note"
                      error={fieldError("audit_note", invalidError, "below")}
                    >
                      {data.status === DELETING_FILE_STATUS_SUBMIT ? (
                        <TextEditor
                          name="audit_note"
                          value={data.audit_note}
                          onChange={setField}
                        ></TextEditor>
                      ) : (
                        <span dangerouslySetInnerHTML={{__html: data.audit_note}}></span>
                      )}
                    </Form.Input>
                  </Form.Group>
                  <div>
                    {data.status < DELETING_FILE_STATUS_SUBMIT && currentUser.permissions.file_sync.delete_file.delete && (
                      <Button primary onClick={e => {
                        setToStatus(DELETING_FILE_STATUS_SUBMIT);
                      }}>Submit</Button>
                    )}
                    {data.status === DELETING_FILE_STATUS_SUBMIT && currentUser.permissions.file_sync.delete_file.audit && (
                      <>
                        <Button
                          primary
                          onClick={(e) => {
                            setToStatus(DELETING_FILE_STATUS_APPROVE);
                          }}
                        >
                          Approvel
                        </Button>
                        <Button
                          secondary
                          onClick={(e) => {
                            setToStatus(DELETING_FILE_STATUS_DISAPPROVE);
                          }}
                        >
                          Disapprovel
                        </Button>
                      </>
                    )}
                    <Button as="a" onClick={(e) => modalControl.setOpen(false)}>
                      Close
                    </Button>
                  </div>
                </Form>
              </Segment>
            </Segment.Group>
          </Modal.Content>
        </Modal>
      </>
    );
}